import { FunctionComponent } from 'react';
import { parseHtml } from '../OldSurvey/Helper';

interface FooterContentProps {
  htmlString?: string;
}

export const FooterContent: FunctionComponent<FooterContentProps> = ({ htmlString }) => {
  return (
    <>
      {htmlString && (
        <>
          {parseHtml(htmlString)} <br />
        </>
      )}
    </>
  );
};
